export const getFactionIconPath = (factionId) => {
  if (!factionId) {
    return `/img/other/strategikon_bust.png`
  }
  return `/img/factions/icons/icon_${factionId}.png`;
}